export default "__VITE_ASSET__CQre3uF5__"